"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableStyles = void 0;
var core_1 = require("@material-ui/core");
var _colors_1 = require("../../../style/commons/_colors");
exports.useTableStyles = (0, core_1.makeStyles)(function () { return ({
    container: {
        width: '100%',
        tableLayout: 'fixed',
    },
    headers: {
        height: 40,
        width: '100%',
        color: _colors_1.darkSecondary,
        backgroundColor: _colors_1.secondaryColor,
        display: 'flex',
        alignItems: 'center',
        borderRadius: '4px',
    },
    header: {
        padding: 8,
        textAlign: 'left',
    },
    draggableHeaderContainer: {
        width: 60,
    },
    checkbox: {
        margin: 0,
    },
    scrollEndedMessage: {
        textAlign: 'center',
        margin: 16,
    },
}); });
